<app-dialog [config]="createAutomaticMatchingConfig"></app-dialog>
